import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-retry-send-fax",
  templateUrl: "./retry-send-fax.component.html",
  styleUrls: ["./retry-send-fax.component.scss"],
})
export class RetrySendFaxComponent {
  @Input() errorMessage = "";

  @Output() retry = new EventEmitter<void>();
}
